module.exports = __webpack_public_path__ + "static/media/diffusion_plastic.9f7ea2e3.jpg";